import React from 'react';
import Stats from '../../../components/Stats';
import { activeStatsIcon, correctionStatsIcon, lateStatsIcon, statsCompletedIcon, tripStatsIcon } from '../../../utils/svgs';
import { FiCheckCircle, FiAlertOctagon, FiCheck, FiAlertCircle } from 'react-icons/fi';
import { BsMap } from 'react-icons/bs';

const formatStatValue = (val, fallback = "0") => {
    if (val === null || val === undefined) return fallback;
    if (typeof val === 'object') {
        const result = val.total_trips ?? val.total ?? val.count;
        return result !== undefined && result !== null ? result : fallback;
    }
    return val;
};

const TripsListStats = ({ overviewData }) => {
    const lastUpdatedDate = overviewData?.totalTrips?.lastUpdated
        ? new Date(overviewData?.totalTrips?.lastUpdated).toLocaleDateString()
        : new Date().toLocaleDateString('en-GB');

    // Desktop Stats Data (5 Cards)
    const tripStatsData = [
        {
            title: "Total Trips",
            value: overviewData?.totalTrips?.total_trips ?? overviewData?.totalTrips?.total ?? "0",
            text: (
                <>
                    <span>Last updated: </span>
                    <b>{lastUpdatedDate}</b>
                </>
            ),
            icon: tripStatsIcon,
        },
        {
            title: "New/In Transit",
            value: overviewData?.newInTransitTrips?.total ?? "0",
            text: (
                <>
                    <b>{overviewData?.newInTransitTrips?.info ?? "0"}% </b>
                    <span>from total</span>
                </>
            ),
            icon: activeStatsIcon,
        },
        {
            title: "Completed",
            value: overviewData?.completeTrips?.total ?? overviewData?.completedTrips?.total ?? "0",
            text: (
                <>
                    <b>{overviewData?.completeTrips?.info ?? overviewData?.completedTrips?.info ?? "0"}% </b>
                    <span>from total</span>
                </>
            ),
            icon: statsCompletedIcon,
            className: "completed",
        },
        {
            title: "Correction Trips",
            value: overviewData?.correctionTrips?.total ?? "0",
            text: (
                <>
                    <b>{overviewData?.correctionTrips?.info ?? "0"}% </b>
                    <span>from total</span>
                </>
            ),
            icon: correctionStatsIcon,
            className: "correction",
        },
        {
            title: "Closed",
            value: overviewData?.closedTrips?.total ?? "0",
            text: (
                <>
                    <b>{overviewData?.closedTrips?.info ?? "0"}% </b>
                    <span>from total</span>
                </>
            ),
            icon: lateStatsIcon,
            className: "late",
        },
    ];

    // Mobile Screenshot Compact Stats
    const mobileStats = [
        {
            title: "Total Trips",
            value: formatStatValue(overviewData?.totalTrips, "0"),
            barColor: "#1447b1",
            trend: <span className="stat_trend_gray">Last updated : {lastUpdatedDate}</span>,
            icon: <BsMap className="stat_icon_svg" />,
        },
        {
            title: "New/In Transit",
            value: formatStatValue(overviewData?.newInTransitTrips, "0"),
            barColor: "#1447b1",
            trend: (
                <span className="stat_trend_text">
                    <strong className="purple_pct">{formatStatValue(overviewData?.newInTransitTrips?.info, "0")}%</strong> from total
                </span>
            ),
            icon: <FiCheckCircle className="stat_icon_svg" />,
        },
        {
            title: "Completed",
            value: formatStatValue(overviewData?.completeTrips || overviewData?.completedTrips, "0"),
            barColor: "#16a34a",
            trend: (
                <span className="stat_trend_text">
                    <strong className="purple_pct">{formatStatValue(overviewData?.completeTrips?.info || overviewData?.completedTrips?.info, "0")}%</strong> from total
                </span>
            ),
            icon: (
                <div className="stat_completed_badge">
                    <FiCheck className="stat_check_svg" />
                </div>
            ),
        },
        {
            title: "Correction Trips",
            value: formatStatValue(overviewData?.correctionTrips, "0"),
            barColor: "#f59e0b",
            trend: (
                <span className="stat_trend_text">
                    <strong className="purple_pct">{formatStatValue(overviewData?.correctionTrips?.info, "0")}%</strong> from total
                </span>
            ),
            icon: <FiAlertCircle className="stat_icon_svg" />,
        },
        {
            title: "Closed",
            value: formatStatValue(overviewData?.closedTrips, "0"),
            barColor: "#dc2626",
            trend: (
                <span className="stat_trend_text">
                    <strong className="purple_pct">{formatStatValue(overviewData?.closedTrips?.info, "0")}%</strong> from total
                </span>
            ),
            icon: <FiAlertOctagon className="stat_icon_svg" />,
        },
    ];

    return (
        <>
            {/* Desktop Stats (Exact same as Trips.jsx) */}
            <div className="desktop_stats_only">
                <Stats statsData={tripStatsData} numberOfColumn={3} />
            </div>

            {/* Mobile Screenshot Exact Stats */}
            <div className="mobile_stats_only figma_exact_stats_grid">
                {mobileStats.map((item, idx) => (
                    <div className="figma_stat_card" key={idx}>
                        <div className="stat_card_top_row">
                            <span className="stat_card_title">{item.title}</span>
                            <div className="stat_icon_container">{item.icon}</div>
                        </div>

                        <div className="stat_card_value_row">
                            <span 
                                className="stat_color_bar" 
                                style={{ backgroundColor: item.barColor }}
                            />
                            <span className="stat_card_count">{item.value}</span>
                        </div>

                        <div className="stat_card_bottom_row">
                            {item.trend}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default TripsListStats;
